import http from '@/http'
const URL = '/admin/faqs'

export const listFaqs = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const getFaq = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const saveFaq = (payload) => {
  if (!payload.id) {
    return http.post(URL, payload)
  }
  return http.put(URL + `/${payload.id}`, payload)
}

export const changeStatus = (payload) => http.put(URL + `/${payload}/status`)

export const deleteFaq = async (id) => http.delete(URL + `/${id}`)

export const orderList = async (payload) => http.put(URL + `/reorder`, payload)

export default {
  listFaqs,
  getFaq,
  saveFaq,
  changeStatus,
  deleteFaq,
  orderList
}
